import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DUNONHANVAY } from "../actions/DuNoNhanVay/actionTypes";
import {
  getListDuNoNhanVaySuccess,
  getListDuNoNhanVayFailure,
} from "../actions/DuNoNhanVay";
import DuNoNhanVayApi from "../service/duNoNhanVayApi";

function* getListDuNoNhanVay(action) {
  try {
    const response = yield call(DuNoNhanVayApi.list1, action.dataSearch);
    if (response.ok) {
      yield put(getListDuNoNhanVaySuccess(response.data));
    } else {
      yield put(getListDuNoNhanVayFailure());
    }
  } catch (error) {
    yield put(getListDuNoNhanVayFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DUNONHANVAY, getListDuNoNhanVay);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
